import { useResetRecoilState } from 'recoil';
import { childFirstNameState, childLastNameState, childDobState, childHeightOptionState } from './child-details';
import {
  parentFirstNameState,
  parentLastNameState,
  marketingPermissionState,
  parentSignatureState,
  parentSignatureDateState,
} from './parent-details';

export const useResetStoreExceptEmail = () => {
  const resetChildFirstName = useResetRecoilState(childFirstNameState);
  const resetChildLastName = useResetRecoilState(childLastNameState);
  const resetChildDob = useResetRecoilState(childDobState);
  const resetHeight = useResetRecoilState(childHeightOptionState);
  const resetParentFirstName = useResetRecoilState(parentFirstNameState);
  const resetParentLastName = useResetRecoilState(parentLastNameState);
  const resetMarketingPermission = useResetRecoilState(marketingPermissionState);
  const resetSignature = useResetRecoilState(parentSignatureState);
  const resetSignatureDate = useResetRecoilState(parentSignatureDateState);

  const resetStoreExceptEmail = () => {
    resetChildFirstName();
    resetChildLastName();
    resetChildDob();
    resetHeight();
    resetParentFirstName();
    resetParentLastName();
    resetMarketingPermission();
    resetSignature();
    resetSignatureDate();
  };

  return resetStoreExceptEmail;
};
